import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessToken: null,         // kısa ömürlü access token (memory)
  accessExp: null,           // access token expiry (unix timestamp - saniye)
  me: null,                  // /auth/me sonucu
  status: "unauthenticated", // unauthenticated | authenticated

  allowAutoRefresh: false,   // kullanıcı izin vermeden refresh yok
  extensionsLeft: 1,         // sadece 1 kez uzatabilir
};

const sessionSlice = createSlice({
  name: "session",
  initialState,
  reducers: {
    // Login / refresh sonrası: token + exp set edilir
    setAccess(state, action) {
      const { token, exp } = action.payload;
      state.accessToken = token;
      state.accessExp = exp ?? null;
      state.status = token ? "authenticated" : "unauthenticated";
    },

    // /auth/me sonrası: kullanıcı bilgisi set edilir
    setMe(state, action) {
      state.me = action.payload;
      state.status = action.payload ? "authenticated" : "unauthenticated";
    },

    /**
     * Login olduğunda (veya yeni oturum başlatıldığında) policy reset:
     * - 1 kez uzatma hakkı ver
     * - refresh iznini kapat (popup'tan Evet demeden refresh yok)
     */
    resetSessionPolicy(state) {
      state.allowAutoRefresh = false;
      state.extensionsLeft = 1;
    },

    /**
     * Kullanıcı popup'ta "Evet" dediğinde:
     * - refresh'e bir kere izin verebiliriz
     * (refresh başarılı olunca consumeExtension çağıracağız)
     */
    armAutoRefresh(state) {
      state.allowAutoRefresh = true;
    },

    /**
     * Refresh başarılı olunca:
     * - uzatma hakkını düşür
     * - tekrar otomatik refresh iznini kapat
     */
    consumeExtension(state) {
      state.extensionsLeft = Math.max(0, state.extensionsLeft - 1);
      state.allowAutoRefresh = false;
    },

    /**
     *manuel set de kalsın (genel amaçlı)
     */
    setAllowAutoRefresh(state, action) {
      state.allowAutoRefresh = Boolean(action.payload);
    },

    // Çıkış (kullanıcı hayır dedi, süre doldu, refresh izni yokken 401 geldi vs.)
    logout(state) {
      state.accessToken = null;
      state.accessExp = null;
      state.me = null;
      state.status = "unauthenticated";
      state.allowAutoRefresh = false; // default: izin yok
      state.extensionsLeft = 1;       // istersek 1'e dönsün; login olunca zaten resetlenecek
    },
  },
});

export const {
  setAccess,
  setMe,
  resetSessionPolicy,
  armAutoRefresh,
  consumeExtension,
  setAllowAutoRefresh,
  logout,
} = sessionSlice.actions;

export default sessionSlice.reducer;

